module.exports = __webpack_public_path__ + "static/media/other_tools_br.4ee2d5d3.png";